import { render, staticRenderFns } from "./fullreport.vue?vue&type=template&id=740cbee2&"
import script from "./fullreport.vue?vue&type=script&lang=js&"
export * from "./fullreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports